import { settingsPath } from '../services/platform.js';
import { html } from '../lib/html.js';
import { maskCpf, maskPhone, onlyDigits } from '../lib/masks.js';
import { alertController } from '@ionic/core/components';
import { applyApiFieldErrors, autoClearErrors, busy, confirm, setFieldError, toast, toastError, toastSuccess, valueOf, withLoading } from '../lib/ui.js';
import { me } from '../services/me.js';
import { session } from '../services/session.js';
import { config } from '../config.js';
import { push } from '../services/push.js';
import { Page, go } from './base.js';
import { tabbarFooter } from '../lib/tabs.js';
import { initials, openSpaceSheet, spaceButton } from '../lib/space-ui.js';
import { space } from '../services/space.js';
import { APPEARANCES, theme } from '../services/theme.js';

const ROLE_LABEL = { USER: 'Proprietário', MECHANIC: 'Profissional' };

class ProfilePage extends Page {
  template() {
    return html`
      <ion-content class="ion-padding tc-page root-page has-tabbar" fullscreen>
        <div class="narrow">
          <div class="top-row space-slot"></div>
          <h1 class="page-title">Conta</h1>

          <div class="panel account-card" style="margin-top:14px">
            <span class="avatar lg me-initials"></span>
            <div class="row-main">
              <span class="row-title me-name"></span>
              <span class="row-sub email"></span>
            </div>
          </div>

          <div class="company-slot"></div>

          <div class="sec-title"><h2>Dados pessoais</h2></div>
          <form novalidate>
            <ion-list lines="none" class="form">
              <ion-input name="name" label="Nome completo" label-placement="floating" fill="outline" autocomplete="name"></ion-input>
              <ion-input name="phone" label="Celular" label-placement="floating" fill="outline" inputmode="tel" maxlength="15"></ion-input>
            </ion-list>
            <ion-button type="submit" expand="block" class="submit">Salvar alterações</ion-button>
          </form>
          <div class="panel" style="margin-top:12px">
            <div class="kv"><span>CPF</span><strong class="cpf mono"></strong></div>
            <div class="kv"><span>Perfil</span><strong class="role"></strong></div>
          </div>

          <div class="sec-title"><h2>Aparência</h2></div>
          <div class="seg appearance" role="radiogroup" aria-label="Aparência">
            ${APPEARANCES.map((a) => html`<button type="button" role="radio" data-appearance="${a.key}">${a.label}</button>`)}
          </div>
          <p class="list-note" style="margin:8px 4px 0">Automático segue o modo claro ou escuro do celular.</p>

          <div class="sec-title"><h2>Notificações</h2></div>
          <div class="panel">
            <button type="button" class="row tappable push-toggle">
              <span class="settings-ic blue"><ion-icon name="notifications-outline"></ion-icon></span>
              <span class="row-main"><span class="row-title">No celular (push)</span><span class="row-sub push-hint">Revisões, empresas e documentos</span></span>
              <span class="push-state row-meta"></span>
            </button>
            <button type="button" class="row tappable email-toggle">
              <span class="settings-ic violet"><ion-icon name="mail-outline"></ion-icon></span>
              <span class="row-main"><span class="row-title">Lembretes por e-mail</span><span class="row-sub email-hint">Revisões chegando ou vencidas</span></span>
              <span class="email-state row-meta"></span>
            </button>
            <button type="button" class="row tappable more-row push-test" style="display:none">Enviar notificação de teste</button>
          </div>
          <p class="list-note" style="margin:8px 4px 0">Avisos da conta (documento analisado, serviço registrado, acesso de empresa) também chegam por e-mail.</p>

          <div class="sec-title"><h2>Privacidade</h2></div>
          <div class="panel">
            <a class="row tappable" href="${config.site.terms}" target="_blank" rel="noopener">
              <span class="settings-ic gray"><ion-icon name="document-text-outline"></ion-icon></span>
              <span class="row-main"><span class="row-title">Termos de uso</span></span>
              <ion-icon class="chevron" name="chevron-forward"></ion-icon>
            </a>
            <a class="row tappable" href="${config.site.privacy}" target="_blank" rel="noopener">
              <span class="settings-ic green"><ion-icon name="shield-checkmark-outline"></ion-icon></span>
              <span class="row-main"><span class="row-title">Política de privacidade</span></span>
              <ion-icon class="chevron" name="chevron-forward"></ion-icon>
            </a>
          </div>

          <div class="actions" style="margin-top:24px">
            <ion-button expand="block" fill="outline" color="danger" class="logout">
              <ion-icon slot="start" name="log-out-outline"></ion-icon>
              Sair da conta
            </ion-button>
            <ion-button expand="block" fill="clear" color="danger" class="delete-account">
              <ion-icon slot="start" name="trash-outline"></ion-icon>
              Excluir minha conta
            </ion-button>
          </div>
          <p class="app-version">versão ${config.bundleVersion}${config.appEnv === 'prd' ? '' : ` · ${config.appEnv.toUpperCase()}`}</p>
        </div>
      </ion-content>
      ${tabbarFooter('profile')}`;
  }

  setup() {
    autoClearErrors(this);
    const phone = this.$('ion-input[name="phone"]');
    phone.addEventListener('ionInput', () => (phone.value = maskPhone(phone.value)));
    this.$('form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.save();
    });
    this.$('.logout').addEventListener('click', () => this.logout());
    this.$('.delete-account').addEventListener('click', () => this.deleteAccount());
    this.$('.push-toggle').addEventListener('click', () => this.togglePush());
    this.$('.push-test').addEventListener('click', () => this.testPush());
    this.$('.email-toggle').addEventListener('click', () => this.toggleEmail());
    this.$('.appearance').addEventListener('click', (e) => {
      const b = e.target.closest('[data-appearance]');
      if (!b) return;
      theme.set(b.dataset.appearance);
      this.renderAppearance();
    });
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-action="space"]')) return openSpaceSheet();
      const sw = e.target.closest('[data-switch]');
      if (sw) {
        space.set(sw.dataset.switch);
        return go(space.home(sw.dataset.switch), 'root');
      }
      const g = e.target.closest('[data-go]');
      if (g) go(g.dataset.go);
    });
  }

  renderAppearance() {
    const cur = theme.preference;
    this.querySelectorAll('[data-appearance]').forEach((b) => {
      b.classList.toggle('on', b.dataset.appearance === cur);
      b.setAttribute('aria-checked', String(b.dataset.appearance === cur));
    });
  }

  /** Área da empresa: trocar de espaço (quem é membro) ou cadastrar/entrar numa empresa. */
  renderCompany() {
    const w = me.current?.workshop;
    const biz = space.current === 'business';
    this.$('.space-slot').innerHTML = spaceButton().value ?? '';
    this.$('.company-slot').innerHTML = (w
      ? html`
        <div class="sec-title"><h2>Empresa</h2></div>
        <div class="panel">
          <button type="button" class="row tappable" data-switch="${biz ? 'personal' : 'business'}">
            <span class="settings-ic ${biz ? 'blue' : 'orange'}"><ion-icon name="${biz ? 'person-outline' : 'storefront-outline'}"></ion-icon></span>
            <span class="row-main"><span class="row-title">${biz ? 'Ir para o espaço Pessoal' : `Ir para ${w.name}`}</span><span class="row-sub">${biz ? 'Sua garagem, lembretes e busca' : `Painel, veículos e equipe · ${w.role === 'MANAGER' ? 'Responsável' : 'Profissional'}`}</span></span>
            <ion-icon class="chevron" name="swap-horizontal-outline"></ion-icon>
          </button>
        </div>`
      : html`
        <div class="sec-title"><h2>Empresa</h2></div>
        <button type="button" class="panel row tappable" data-go="/empresa/cadastrar">
          <span class="settings-ic orange"><ion-icon name="storefront-outline"></ion-icon></span>
          <span class="row-main"><span class="row-title">Sua empresa faz manutenção?</span><span class="row-sub">Cadastre grátis (linha leve, pesada ou agrícola) ou aceite o convite da sua equipe.</span></span>
          <ion-icon class="chevron" name="chevron-forward"></ion-icon>
        </button>`).value;
  }

  onEnter() {
    this.$('tc-tabbar')?.refresh();
    const u = me.current?.user;
    if (!u) return;
    this.$('ion-input[name="name"]').value = u.name;
    this.$('ion-input[name="phone"]').value = u.phone ? maskPhone(u.phone) : '';
    this.$('.email').textContent = u.email;
    this.$('.me-name').textContent = u.name;
    this.$('.me-initials').textContent = initials(u.name);
    this.renderAppearance();
    this.renderCompany();
    this.$('.cpf').textContent = maskCpf(u.cpf);
    this.$('.role').textContent = ROLE_LABEL[u.role] ?? u.role;
    this.renderPush();
    this.renderEmail();
  }

  /** Lembretes por e-mail (os avisos de conta sempre vão). E-mail devolvido: pede para conferir o endereço. */
  renderEmail() {
    const u = me.current?.user;
    const on = u?.emailReminders !== false;
    const problem = u?.emailStatus === 'BOUNCED' ? 'Seu e-mail voltou sem ser entregue. Confira o endereço com o suporte.' : u?.emailStatus === 'COMPLAINED' ? 'Você marcou nossos e-mails como spam; não enviamos mais.' : '';
    this.$('.email-state').textContent = problem ? 'Parados' : on ? 'Ligados' : 'Desligados';
    this.$('.email-state').style.color = on && !problem ? 'var(--tc-ok-text)' : '';
    this.$('.email-hint').textContent = problem || 'Revisões chegando ou vencidas';
  }

  async toggleEmail() {
    const u = me.current?.user;
    if (!u) return;
    const turnOn = u.emailReminders === false;
    try {
      await me.update({ emailReminders: turnOn });
      toastSuccess(turnOn ? 'Lembretes por e-mail ligados.' : 'Lembretes por e-mail desligados.');
    } catch (err) {
      toastError(err.message);
    }
    this.renderEmail();
  }

  async save() {
    const name = valueOf(this, 'name');
    const phone = valueOf(this, 'phone');
    let ok = true;
    if (name.length < 3) (ok = false), setFieldError(this.$('ion-input[name="name"]'), 'Informe seu nome completo');
    if (phone && onlyDigits(phone).length < 10) (ok = false), setFieldError(this.$('ion-input[name="phone"]'), 'Celular inválido');
    if (!ok) return;

    await busy(this.$('.submit'), async () => {
      try {
        await me.update({ name, ...(phone ? { phone } : {}) });
        toastSuccess('Perfil atualizado.');
      } catch (err) {
        if (!applyApiFieldErrors(this, err.details)) toastError(err.message);
      }
    });
  }

  /** Estado das notificações: preferência da conta + permissão do aparelho. */
  async renderPush() {
    const u = me.current?.user;
    const perm = await push.permission().catch(() => 'unsupported');
    const on = u?.pushEnabled !== false && perm === 'granted';
    this.$('.push-state').textContent = perm === 'unsupported' ? 'Só no app' : perm === 'denied' ? 'Bloqueadas' : on ? 'Ligadas' : 'Desligadas';
    this.$('.push-state').style.color = on ? 'var(--tc-ok-text)' : '';
    this.$('.push-hint').textContent = perm === 'denied' ? 'Libere em Configurações › Apps › TicketCar › Notificações' : 'Revisões, empresas e documentos';
    this.$('.push-test').style.display = on ? '' : 'none';
  }

  async togglePush() {
    const u = me.current?.user;
    if (!u) return;
    const perm = await push.permission().catch(() => 'unsupported');
    if (perm === 'unsupported') return toast('As notificações funcionam no app do celular.');
    const turnOn = !(u.pushEnabled !== false && perm === 'granted');
    try {
      if (turnOn) {
        const p = await push.enable();
        if (p !== 'granted') {
          toastError(`As notificações estão bloqueadas. Libere em ${settingsPath('notifications')}.`);
          return this.renderPush();
        }
      }
      await me.update({ pushEnabled: turnOn });
      toastSuccess(turnOn ? 'Notificações ligadas.' : 'Notificações desligadas.');
    } catch (err) {
      toastError(err.message);
    }
    this.renderPush();
  }

  async testPush() {
    try {
      const r = await push.test();
      if (!r.enabled) return toast('O envio de notificações ainda não está configurado neste ambiente.');
      toast(r.sent ? 'Enviada! Ela chega em alguns segundos.' : 'Nenhum aparelho registrado. Feche e abra o app e tente de novo.');
    } catch (err) {
      toastError(err.message);
    }
  }

  /**
   * Exclusão de conta: explica o que acontece e pede "EXCLUIR" digitado.
   * O histórico de manutenção fica com o veículo (sem os seus dados pessoais).
   */
  async deleteAccount() {
    const a = await alertController.create({
      header: 'Excluir sua conta?',
      message:
        'Isto não pode ser desfeito. Seu login, nome, CPF, telefone e documentos (CRLV-e) serão apagados, e você perde o acesso aos veículos. ' +
        'O histórico de manutenção continua com cada veículo, sem os seus dados. Digite EXCLUIR para confirmar.',
      inputs: [{ name: 'confirm', type: 'text', placeholder: 'EXCLUIR', attributes: { autocapitalize: 'characters' } }],
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        { text: 'Excluir conta', role: 'confirm', cssClass: 'alert-button-danger' },
      ],
    });
    await a.present();
    const { role, data } = await a.onDidDismiss();
    if (role !== 'confirm') return;
    const typed = String(data?.values?.confirm ?? '').trim().toUpperCase();
    if (typed !== 'EXCLUIR') return toastError('Digite EXCLUIR para confirmar a exclusão.');
    try {
      await withLoading('Excluindo sua conta...', () => me.deleteAccount(typed));
    } catch (err) {
      return toastError(err.message);
    }
    await session.signOut();
    go('/login', 'root');
    toast('Sua conta foi excluída.', 'dark', 4000);
  }

  async logout() {
    const sure = await confirm({ header: 'Sair da conta?', confirmText: 'Sair', destructive: true });
    if (!sure) return;
    await session.signOut();
    go('/login', 'root');
  }
}

customElements.define('page-profile', ProfilePage);
